enum SHARED_ANALYTICS_VALUES {
	VERIFY_MOBILE = 'verify your mobile number',
	VERIFY_EMAIL = 'verify your email',
	LOCKED_ACCOUNT = 'general account lock',
}

export enum EVENT_TRACKERS {
	CLICK_BUTTON = 'click button',
	CLICK_LINK = 'click link',
	CLICK_INPUT = 'click input',
	CLICK_RADIO = 'click radio',
	START = 'start',
	VIEW = 'view',
	SCREEN_LOAD = 'screen load',
	ON_ERROR = 'on error',
	EDIT = 'edit',
	EDIT_ADDRESS = 'edit address',
	EDIT_EMAIL = 'edit email',
	EDIT_PHONE = 'edit phone',
	EDIT_MOBILE = 'edit mobile',
	CANCEL = 'cancel',
	CANCEL_EMAIL = 'cancel email',
	CANCEL_PHONE = 'cancel phone',
	CANCEL_MOBILE = 'cancel mobile',
	CANCEL_ADDRESS = 'cancel address',
	CLOSE = 'close',
	ERROR = 'error',
	REFRESH = 'refresh',
	EMAIL = 'email',
	PHONE = 'phone',
	ADDRESS = 'address',
	SPOUSE_CONTRIBUTIONS = 'spouse contributions',
	RECEIVE_SPOUSE_CONTRIBUTIONS = 'receive spouse contributions',
	INPUT_NAME = 'input name',
	INPUT_MOBILE = 'input mobile',
	INVALID_MOBILE = 'invalid mobile',
	INPUT_EMAIL = 'input email',
	BEFORE_SHARING_TOOLTIP = 'before sharing tool tip',
	MESSAGE_OVER_75 = 'message - you are not eligible (over 75)',
	MESSAGE_NO_TFN = 'message - tfn not supplied',
	GO_TO_HOME = 'go to home',
	SHOW_PASSWORD = 'show password',
	SHOW_CONFIRM_PASSWORD = 'show confirm password',
	SUBMIT_FORM = 'submit form',
	BACK_TO_LOGIN = 'back to login',
	SUCCESS = 'success',
	FAIL = 'fail',
	FIELD_INPUT = 'field input',
	SUBMIT = 'submit',
	QUERY_LINK = 'query link',
	CONFIRM = 'confirm',
}

export enum EVENT_SECTIONS {
	CONTRIBUTIONS = 'contributions',
	SECURITY = 'security',
	ACCOUNT_ACCESS = 'account access',
	MODULE = 'module',
	MODULES = 'modules',
	MODAL = 'modal',
	ACCOUNT_SNAPSHOT = 'account snapshot',
	CHOICE_INCOME = 'choice income',
	CHOICE_INCOME_INVESTMENT = 'choice income investment',
	SUPER_INVESTMENTS = 'super investments',
	PAYMENT_INFORMATION = 'payment information',
	DASHBOARD = 'dashboard',
	SIMPLE_CONSOLIDATION = 'simple consolidation',
	SIMPLE_ADVICE = 'simple advice',
	IGNITION = 'ignition',
	HOW_WE_USE_COOKIES = 'how we use cookies',
	IDENTITY_VERIFICATION = 'identity verification',
}

export enum EVENT_TYPE {
	OTP = 'one time passcode',
	LOGIN = 'login',
	LOGOUT = 'logout',
	MANAGE_LOGIN = 'manage login',
	REGISTRATION = 'register for member portal',
	VERIFICATION = 'verification',
	DASHBOARD = 'dashboard',
	FAILOVER_MODE = 'failover mode',
	VIEW_SIMPLE_ADVICE = 'view simple advice',
	ACCESS_FINANCIAL_ADVICE_ONLINE = 'access financial advice online',
	CTA_CARD = 'cta card',
	TRANSITION_TO_IGN = 'transition to ign',
	ACCOUNT_ACCESS = 'account access',
	CONSENT_MODAL = 'consent modal',
	SECURITY_AND_VERIFICATION = 'security and verification',
	CONTENT_BLOCK = 'content block',
}

export enum EVENT_TITLE {
	SEND_CODE = "we'll send a verification code - authenticated or unauthenticated",
	SEND_AUTH_CODE = "we'll send a verification code - authenticated",
	CONTACT_DETAILS = 'contact details',
	MOBILE = 'mobile',
	COB_PAGE_TITLE = 'Change of Bank Details',
	CALL_US_NOW_TITLE = 'call us to add your contact details for secure access',
	TRUSTED_DEVICES = 'trusted devices',
	TRUSTED_DEVICES_NO_MOBILE = "we don't have your mobile number",
	REGISTRATION_READY = "your account's ready to go",
	MODAL_CANCELLATION = 'are you sure you want to cancel',
	MULTIPLE_ATTEMPTS_LOCK = "we've locked your account due to multiple failed login attempts",
	RESEND_CODE_TITLE = "we've sent you a code",
	REGISTRATION_SETUP = 'set up your username and password',
	LOCKED_ACCOUNT = SHARED_ANALYTICS_VALUES.LOCKED_ACCOUNT,
	VERIFY_MOBILE = SHARED_ANALYTICS_VALUES.VERIFY_MOBILE,
	VERIFY_EMAIL = SHARED_ANALYTICS_VALUES.VERIFY_EMAIL,
	SEND_CODE_MOBILE = "we've sent you a verification code - mobile",
	SEND_CODE_EMAIL = "we've sent you a verification code - email",
	COMPLETE_ACCOUNT_CHECKUP = 'complete account check-up',
	ACCOUNT_SNAPSHOT = 'snapshot',
	MY_INVESTMENTS = 'my investments',
	LATEST_CONTRIBUTIONS = 'latest contributions',
	MY_PAYMENT = 'my payment',
	SOME_ACCOUNT_DATA_NOT_LOADING = "some account data isn't loading right now",
	CONFIRM_PASSWORD_CHANGE = 'confirm password change',
	FUTURE_PLANNING = 'future planning',
	SELECT_A_TOPIC = 'select a topic',
	CONFIRMATION_MODAL = 'confirmation modal',
	LOGGED_OUT = 'logged out',
	FIND_OUT_MORE = 'find out more',
	LOGIN_DETAILS = 'login details',
	USERNAME_PASSWORD = 'username and password',
	IDENTITY_VERIFICATION = 'identity verification',
	ABOUT_IDENTITY_VERIFICATION = 'about identity verification',
	VERIFY_YOUR_IDENTITY = 'verify your identity',
	VERIFY_YOUR_IDENTITY_MODAL = 'verify your identity modal',
	CONFIRM_IDENTITY_MODAL = 'confirm your identity modal',
	SESSION_EXPIRED = 'your session has expired',
	INTRODUCTION = 'introduction',
	CONSENT = 'consent',
	PERSONAL_DETAILS = 'personal details',
	FOLLOW_TO_CONTINUE = 'follow to continue',
	SCAN_QR_CODE = 'scan the qr code',
	CONTINUE_ON_YOUR_PHONE = 'continue on your phone',
	VERIFYING_YOUR_IDENTITY = 'verifying your identity',
	CONFIRMING_YOUR_IDENTITY = 'confirming your identity',
	YOUR_IDENTITY_IS_VERIFIED = 'your identity is verified',
	IDV_LOCKED = 'your identity verification is locked',
	IDV_MISMATCH = "your information doesn't match our record",
	IDV_CANT_VERIFY = "your identity can't be verified",
	SERVICE_UNAVAILABLE = 'service unavailable',
	LAST_LOGIN = 'last login',
}

export enum EVENT_LABEL {
	BACK = 'back',
	GO_BACK = 'go back',
	CONTINUE = 'continue',
	GOOGLE_PLAY_DOWNLOAD = 'get it on google play',
	APPLE_APP_STORE_DOWNLOAD = 'download on the app store',
	SCAN_QR_CODE = 'scan qr code to download app',
	SCAN_QR_QUERY_LINK = 'scan qr code (query link)',
	LOG_IN_TO_ACCOUNT = 'log in to your account',
	LOCKED_ACCOUNT = SHARED_ANALYTICS_VALUES.LOCKED_ACCOUNT,
	CONTACT_SUPPORT = 'contact support',
	CHANGE_PASSWORD = 'change your password',
	CALL_US = 'call us',
	RESEND_CODE_LABEL = 'resend code',
	SEND_CODE = 'send code',
	INPUT_VERIFICATION_CODE = 'input verification code',
	CONTACT_US = 'contact us',
	SEND_CODE_EMAIL_MOBILE = 'send code to email address or mobile number',
	VERIFY_MOBILE = SHARED_ANALYTICS_VALUES.VERIFY_MOBILE,
	VERIFY_EMAIL = SHARED_ANALYTICS_VALUES.VERIFY_EMAIL,
	RESEND_CODE_MOBILE = 'resend code - mobile number',
	RESEND_CODE_EMAIL = 'resend code - email',
	VIEW_TASKS = 'view tasks',
	UPDATE_YOUR_EMAIL = 'update your email',
	VIEW_OTP_REQUEST = 'view otp request',
	ABOUT_YOUR_BALANCE_AND_RETURNS = 'about your balance and returns',
	VIEW_BALANCE_DETAILS = 'view balance details',
	LOG_OUT = 'log out',
	UPDATE_PASSWORD = 'update password',
	GO_TO_ADVICE_DASHBOARD = 'go to advice dashboard',
	PRIVACY_POLICY = 'privacy policy',
	VIEW = 'view',
	DISMISS = 'dismiss',
	CLOSE_TAB = 'close tab',
	LOG_IN_AGAIN = 'log in again',
	ACCEPT_ALL_COOKIES = 'accept all cookies',
	REJECT_NON_ESSENTIAL_COOKIES = 'reject non-essential cookies',
	MANAGE = 'manage',
	VERIFY = 'verify',
	LEARN_MORE_IDV = 'learn more about identity verification and documents',
	INLINE_SUCCESS_BANNER = 'inline green banner',
	FAQ = 'frequently asked questions',
	MAYBE_LATER = 'maybe later',
	IDV_CANCEL_CONTINUE_MODAL = 'are you sure you want to cancel modal',
	SELECT_CHECKBOX = 'select checkbox',
	UNSELECT_CHECKBOX = 'unselect checkbox',
	CHANGE_DETAILS_TOOLTIP = 'how can i change my details',
	UPDATING_YOUR_DETAILS_MODAL = 'updating your details modal -',
	GENERATE_CODE_LABEL = 'generate a code',
	GENERATE_NEW_CODE_LABEL = 'generate a new code',
	START_AGAIN = 'start again',
	DVS_PRIVACY_STATEMENT = 'dvs privacy statement',
	PRIVACY_POLICY_AUSTRALIANSUPER = 'privacy policy australiansuper',
	UPDATING_YOUR_DETAILS_MODAL_DOWNLOAD = 'updating your details modal - download change of details form',
	UPDATING_YOUR_DETAILS_MODAL_UPLOAD = 'updating your details modal - upload completed form',
	CLICK_LOCAL_TEL_LINK = 'click local tel link',
	CLICK_OVERSEAS_TEL_LINK = 'click overseas tel link',
	CLICK_UPDATE_YOUR_DETAILS_LINK = 'click update your details link',
}

export enum EVENT_MESSAGE {
	VERIFICATION_STATUS = 'verification status - ',
}
